import React from 'react';
import './Filters.scss';
import './CustomFilters.scss';
import PropTypes from 'prop-types';
import FiltersIcon from 'assets/svgs/filterIconBlue.svg';

const CustomFilters = ({
  title,
  children,
  onClear,
  clear,
  subTitle
}) => (
  <div className="filters-container">
    <div className="filters-header">
      <FiltersIcon className="filter-icon" />
      <div className="filters-title">{title}</div>
      {clear && <div className="filters-clear" onClick={onClear}>{clear}</div>}
    </div>
    <div className="filters-content">
      {subTitle && <div className="filters-subtitle">{subTitle}</div>}
      {children}
    </div>
  </div>
);

export default CustomFilters;

CustomFilters.propTypes = {
  title: PropTypes.string,
  clear: PropTypes.string,
  onClear: PropTypes.func,
  children: PropTypes.node,
};

CustomFilters.defaultProps = {};

